import React from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Navigate } from "react-router-dom";
import CurrentUser from "../queries/CurrentUser";
import { Nav } from "reactstrap";

const CheckAuth = (WrappedComponent) => {
  const AuthenticatedComponent = (props) => {
    const { loading, error, data } = useQuery(
      CurrentUser,
      // { fetchPolicy: "network-only" }
    );

    const location = useLocation();

    console.log("location: ", location);

    if (loading) return null;
    if (error) {
      console.log("error:", error);
      return <p>Something Went Wrong...</p>;
    }

    if (typeof data.currentUser === "undefined" || data.currentUser === null) {
      console.log("navigating to login, current user not found.");
      return <WrappedComponent currentUser={data.currentUser} />;
    } else if (data.currentUser.role === "admin") {
      console.log("navigating to admin dashboard, current user is an admin.");
      return <Navigate to="/admin/dashboard" replace={true} />;
    } else if (data.currentUser.role === "report_viewer") {
      console.log(
        "navigating to reports dashboard, current user is a report viewer.",
      );
      return <Navigate to="/admin/reports" replace={true} />;
    } else if (data.currentUser.role === "user") {
      console.log("navigating to wrapped component since authorized..");
      return <Navigate to="/dashboard" replace={true} />;
    } else {
      console.error("WTF!!!!!");
      return <Navigate to="/login" replace={true} />;
    }
  };

  return <AuthenticatedComponent />;
};

export default CheckAuth;
